export default __webpack_public_path__ + "static/media/PL001.2.6cb232a2.mp3";